module.exports = __webpack_public_path__ + "static/LogosBlack-e25f8950a199a7ba78bcd2f709473edb.svg";